var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_5418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7947 9.75403L19.9247 18.5044L10.1295 8.70926L4.17084 14.6516L3.02808 13.5088L10.1295 6.39099L19.9247 16.1861L27.6519 8.61126L28.7947 9.75403Z",
    fill: "#168004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7947 18.4064L27.6519 19.5491L19.9247 11.9743L11.7621 20.1369L8.49702 16.8718L4.17084 21.1816L3.02808 20.0389L8.49702 14.5536L11.7621 17.8186L19.9247 9.65601L28.7947 18.4064Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7947 9.75409L19.9247 18.5044L15.0271 13.6069V11.2886L19.9247 16.1862L27.6519 8.61133L28.7947 9.75409Z",
    fill: "#168004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7947 18.4064L27.6519 19.5491L19.9247 11.9743L15.0271 16.8718V14.5536L19.9247 9.65601L28.7947 18.4064Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6405 24.6914V26.3023L25.6162 26.3033L15.0271 26.3076L2.7832 26.3131V1.18311H4.41572V24.6914H27.6405Z",
    fill: "#676E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13029 3.45351L3.5998 2.22827L1.95368 3.45351L0.93335 2.17811L3.5998 0.138306L6.15062 2.17811L5.13029 3.45351Z",
    fill: "#676E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6409 24.6914V26.3022L25.6156 26.3037L25.6167 26.3033L15.0276 26.3076V24.6914H27.6409Z",
    fill: "#474F54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7957 25.5076L26.1777 28L25.0234 26.8457L25.6161 26.3037L25.6171 26.3032L26.4872 25.5076L25.6705 24.6913L25.0234 24.0443L26.1777 22.8903L28.7957 25.5076Z",
    fill: "#474F54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_5418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8617,
    height: 27.8617,
    fill: "white",
    transform: "translate(0.93335 0.138306)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/line-icon.d6909aceba43608181172b48cd9be0dc.svg";
export { ForwardRef as ReactComponent };